import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-business-co-setting-cargonizer',
  templateUrl: './business-co-setting-cargonizer.component.html',
  styleUrls: ['./business-co-setting-cargonizer.component.css']
})
export class BusinessCoSettingCargonizerComponent implements OnInit {
    businessCoNo;

    public edit?: Edit;

    public selectListReports: Item[] = [];

    public saving = false;

    public gettingTransportAgreements = false;

    public gettingCargonizerPrinters = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
    }

    private async loadEdit() {
        if (!!this.businessCoNo) {
            this.edit = (await this.datatask.Post(352, { businessco_no: this.businessCoNo }))[0];
        }
    }

    private async loadReports() {
        this.selectListReports = await this.datatask.Post(2648);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(355, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async getTransportAgreements() {
        if (!!this.edit) {
            try {
                this.gettingTransportAgreements = true;

                const response = (await this.datatask.Post(347, { businessco_no: this.edit.businessco_no }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.gettingTransportAgreements = false;
            }
        }
    }

    public async getCargonizerPrinters() {
        if (!!this.edit) {
            try {
                this.gettingCargonizerPrinters = true;

                const response = (await this.datatask.Post(422, { businessco_no: this.edit.businessco_no }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                }
            } finally {
                this.gettingCargonizerPrinters = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadReports();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    businessco_no: string;
    businessco_companyname: string;
    cargonizer_api_key: string;
    cargonizer_sender_id: string;
    cargonizer_testmode: string;
    ean_prefix_dispatch: string;
    cargonizer_case_p2_reportdef_keyno: string;
}
